import { gql } from '../__generated__';

export const COMPANIES_BY_INDUSTRY_QUERY = gql(`
  query CompaniesByIndustry($id: ID!, $limit: Int, $offset: Int) {
    companiesByIndustry(id: $id, limit: $limit, offset: $offset) {
      collection {
        company {
          ...CompanyData
        }
      }
      total
    }
  }
`);
